/**
 * Canonical post-authentication redirect order.
 * Password renewal always wins over branch setup/selection gates.
 */
export function getPostAuthRedirectPath({
  requiresPasswordRenewal,
  branchesInitialized,
  needsBranchAccessWaiting,
  needsBranchSelection,
  defaultPath = '/dashboard',
}) {
  if (requiresPasswordRenewal) {
    return '/renew-password';
  }
  if (!branchesInitialized) {
    return '/branch-initialization';
  }
  if (needsBranchAccessWaiting) {
    return '/branch-access-waiting';
  }
  if (needsBranchSelection) {
    return '/branch-selection';
  }
  return defaultPath;
}
